export default __webpack_public_path__ + "app/images/8803f226b83f3421f65cbda82ac2b093.svg";